import type { SxProps, Theme } from "@mui/material";

// SPは全体的に文字サイズを一段小さくする（一覧用）。
export const listCompactSx: SxProps<Theme> = {
  "& .MuiTypography-h4": { fontSize: "1.4rem" },
  "& .MuiTypography-h5": { fontSize: "1.25rem" },
  "& .MuiTypography-h6": { fontSize: "1.1rem" },
  "& .MuiTypography-subtitle1": { fontSize: "1rem" },
  "& .MuiTypography-body1": { fontSize: "0.95rem" },
  "& .MuiTypography-body2": { fontSize: "0.9rem" },
  "& .MuiTypography-caption": { fontSize: "0.78rem" },
  "& .MuiButton-root": { fontSize: "0.9rem", py: 0.4 },
  "& .MuiChip-root": { height: 24, fontSize: "0.8rem" },
  "& .MuiToggleButton-root": { fontSize: "0.82rem", py: 0.4 },
  "& .MuiInputBase-input": { fontSize: "0.95rem" },
  "& .MuiInputLabel-root": { fontSize: "0.95rem" },
};

// SPは全体的に文字サイズを一段小さくする（詳細用。情報量が多いため一覧より小さい）。
export const detailCompactSx: SxProps<Theme> = {
  "& .MuiTypography-h5": { fontSize: "1.15rem" },
  "& .MuiTypography-h6": { fontSize: "1rem" },
  "& .MuiTypography-subtitle1": { fontSize: "0.9rem" },
  "& .MuiTypography-body1": { fontSize: "0.85rem" },
  "& .MuiTypography-body2": { fontSize: "0.8rem" },
  "& .MuiTypography-caption": { fontSize: "0.7rem" },
  "& .MuiButton-root": { fontSize: "0.8rem", py: 0.4 },
  "& .MuiChip-root": { height: 22, fontSize: "0.7rem" },
  "& .MuiTab-root": { fontSize: "0.8rem", minHeight: 40 },
  "& .MuiInputBase-input": { fontSize: "0.85rem" },
  "& .MuiInputLabel-root": { fontSize: "0.85rem" },
};
